import { Route, Switch } from 'react-router-dom'
import * as ROUTES from './constants/routeConstants'
import {
  AddPaymentExemption,
  CalculateMembershipFee,
  MainPage,
  MembershipFees,
  Messages,
  OwnInformation,
  VersionInfo
} from '../pages'
import { getMessagesTabProps } from '../pages/messages/constants'

const isMessageTabRouteVisible = (tab: string, showNews: boolean) => {
  return (
    getMessagesTabProps(showNews).find((tabProp) => tabProp.tab === tab)
      ?.isHidden !== true
  )
}

interface AppRoutesProps {
  showNews: boolean
}

export const AppRoutes = ({ showNews }: AppRoutesProps) => {
  return (
    <Switch>
      <Route exact path={ROUTES.ROUTE_MAINPAGE}>
        <MainPage showNews={showNews} />
      </Route>
      <Route exact path={ROUTES.ROUTE_OWNINFO}>
        <OwnInformation openTab={ROUTES.OWNINFO_TAB_BASEDETAILS} />
      </Route>
      <Route path={ROUTES.ROUTE_OWNINFO_BASEDETAILS}>
        <OwnInformation openTab={ROUTES.OWNINFO_TAB_BASEDETAILS} />
      </Route>
      <Route path={ROUTES.ROUTE_OWNINFO_MEMBERSHIP}>
        <OwnInformation openTab={ROUTES.OWNINFO_TAB_MEMBERSHIP} />
      </Route>
      <Route path={ROUTES.ROUTE_OWNINFO_EMPLOYMENT}>
        <OwnInformation openTab={ROUTES.OWNINFO_TAB_EMPLOYMENT} />
      </Route>
      <Route path={ROUTES.ROUTE_OWNINFO_ASSIGNMENTS}>
        <OwnInformation openTab={ROUTES.OWNINFO_TAB_ASSIGNMENTS} />
      </Route>
      <Route exact path={ROUTES.ROUTE_MEMBERSHIP_FEES}>
        <MembershipFees />
      </Route>
      <Route exact path={ROUTES.ROUTE_MESSAGES}>
        <Messages
          openTab={ROUTES.MESSAGES_TAB_EMAILS_AND_SMS}
          showNews={showNews}
        />
      </Route>
      <Route path={ROUTES.ROUTE_MESSAGES_EMAILS_AND_SMS}>
        <Messages
          openTab={ROUTES.MESSAGES_TAB_EMAILS_AND_SMS}
          showNews={showNews}
        />
      </Route>
      {isMessageTabRouteVisible(ROUTES.MESSAGES_TAB_LETTERS, showNews) && (
        <Route path={ROUTES.ROUTE_MESSAGES_LETTERS}>
          <Messages openTab={ROUTES.MESSAGES_TAB_LETTERS} showNews={showNews} />
        </Route>
      )}
      {isMessageTabRouteVisible(ROUTES.MESSAGES_TAB_NEWS, showNews) && (
        <Route exact path={ROUTES.ROUTE_MESSAGES_NEWS}>
          <Messages openTab={ROUTES.MESSAGES_TAB_NEWS} showNews={showNews} />
        </Route>
      )}
      {isMessageTabRouteVisible(ROUTES.MESSAGES_TAB_NEWS, showNews) && (
        <Route exact path={`${ROUTES.ROUTE_MESSAGES_NEWS}/:id`}>
          <Messages openTab={ROUTES.MESSAGES_TAB_NEWS} showNews={showNews} />
        </Route>
      )}
      <Route exact path={ROUTES.ROUTE_ADD_PAYMENT_EXEMPTION}>
        <AddPaymentExemption />
      </Route>
      <Route exact path={ROUTES.ROUTE_CALCULATE_MEMBERSHIP_FEE}>
        <CalculateMembershipFee />
      </Route>
      <Route exact path={ROUTES.ROUTE_VERSION_INFO}>
        <VersionInfo />
      </Route>
    </Switch>
  )
}
